module.exports = __webpack_public_path__ + "img/3d-glasses-3.9cd9ec2a.png";